/**
 * BuildingJourneyPreview
 * ----------------------
 * Hidden preview route at /preview/journey-animation-v2. Renders the
 * single-building cutaway concept side-by-side with size guidance for review.
 */
import React, { useEffect } from 'react';
import BuildingDepartmentJourney from '../components/hero/BuildingDepartmentJourney';

const BuildingJourneyPreview = () => {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex,nofollow';
    document.head.appendChild(meta);
    const title = document.title;
    document.title = 'Building Journey — Preview · Successlane';
    return () => {
      document.head.removeChild(meta);
      document.title = title;
    };
  }, []);

  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#FFFBEB',
        padding: '32px 16px 64px',
        fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
      }}
    >
      <div style={{ maxWidth: 1080, margin: '0 auto' }}>
        <div style={{ marginBottom: 24, display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap' }}>
          <div>
            <h1 style={{ margin: 0, fontSize: 24, fontWeight: 700, color: '#0D1F3C', fontFamily: "'Fraunces', serif" }}>
              Building Journey (V2) — Preview
            </h1>
            <p style={{ margin: '6px 0 0', fontSize: 13, color: '#64748B' }}>
              Alternative concept — a single Successlane HQ building cutaway with character zigzagging up 5 floors.
            </p>
          </div>
          <span style={{
            fontSize: 11, fontWeight: 700, padding: '4px 10px',
            background: '#FEF3C7', color: '#92400E', borderRadius: 99,
            letterSpacing: '0.06em', textTransform: 'uppercase',
          }}>
            V2 · Preview
          </span>
        </div>

        <div style={{ marginBottom: 32 }}>
          <BuildingDepartmentJourney />
        </div>

        <div style={{ marginBottom: 32 }}>
          <h2 style={{ margin: '0 0 10px', fontSize: 14, fontWeight: 600, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.07em' }}>
            Mobile (compact) variant
          </h2>
          <div style={{ maxWidth: 480 }}>
            <BuildingDepartmentJourney compact />
          </div>
        </div>

        <div style={{ background: '#fff', border: '1px solid #E5E9F0', borderRadius: 12, padding: '20px 22px' }}>
          <h2 style={{ margin: '0 0 12px', fontSize: 15, fontWeight: 700, color: '#0D1F3C', fontFamily: "'Fraunces', serif" }}>
            What to check
          </h2>
          <ul style={{ margin: 0, paddingLeft: 20, color: '#475569', fontSize: 13, lineHeight: 1.7 }}>
            <li>The character walks across Floor 1 (Reception → Free Eval), takes the elevator up</li>
            <li>Floor 2 (Checkout — ₹999 + Order ID stamp), elevator up</li>
            <li>Floor 3 (Expert Rewrite — AI workstations + monitor pulse), elevator up</li>
            <li>Floor 4 (Recruiter Cert — recruiter person at desk + sparkles + ✓ stamp pops in), elevator up</li>
            <li>Floor 5 (Delivery — letter coming out of mailbox + globe + "DELIVERED TO INBOX") <strong>+ confetti</strong> fires when character arrives</li>
            <li>The whole journey loops in ~22 seconds</li>
            <li>Click any floor → flipbook info-card opens</li>
            <li>The pill in the top-right updates as the character changes floor</li>
            <li>Compare against <a href="/preview/journey-animation" style={{ color: '#1A6FD6' }}>/preview/journey-animation</a> (V3 cityscape)</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default BuildingJourneyPreview;
